import { ScreenUtil } from '@getgo/chameleon-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';
import windowSize from 'react-window-size';
import SessionsContainer from '../Sessions/SessionsContainer';
import FooterComponent from '../../Application/Footer/FooterComponent';
import HeaderContainer from '../../Application/Header/HeaderContainer';
import NotFoundComponent from '../../Components/ErrorComponents/NotFoundComponent';
import AnalyticsDashboardHeader from './Header/AnalyticsDashboardHeader';
import SessionDetailsContainer from '../Sessions/SessionDetails/SessionDetailsContainer';
import RecordingsContainer from '../../GoToWebinar/Recordings/RecordingsContainer';
import { trackAnalyticsDashboard } from '../../Telemetry/Mixpanel/Features/analyticsTracker';
import { LANDING_PAGE } from '../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { getLastTenSessions } from '../../Reducks/Sessions/SessionsActions';
import { getWebinars } from '../../Reducks/Webinars/WebinarsActions';
import { getRecordings } from '../../Reducks/Recordings/RecordingsActions';
import { getVirtualEvents } from '../../Reducks/VirtualEvents/VirtualEventsActions';
import './AnalyticsDashboard.css';
import RecordingDetailsContainer from '../Recordings/RecordingDetails/RecordingDetailsContainer';
import RobotMessageComponent from '../../Components/RobotMessageComponent/RobotMessageComponent';
import {
  DARK_MODE,
  DARK_MODE_VARIABLES,
  NEW_EXP_LIGHT_MODE,
  LIGHT_MODE_VARIABLES,
  RobotMessageState
} from '../../Utils/Constants';
import { appCuesPage } from '../../Utils/Appcues';
import cssVars from 'css-vars-ponyfill';

export class AnalyticsDashboard extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    windowWidth: PropTypes.number,
    windowHeight: PropTypes.number,
    reduced_user: PropTypes.object,
    requestSessions: PropTypes.func,
    requestWebinars: PropTypes.func,
    requestRecordings: PropTypes.func,
    requestVirtualEvents: PropTypes.func,
    match: PropTypes.object
  };
  constructor(props) {
    super(props);
    const {
      match: { params },
      history
    } = props;
    if (params && params.accountKey) {
      history.push('/analytics/sessions');
    }
    this.sessionsTips = [];
    this.recordingTips = [];
  }
  componentDidMount() {
    cssVars({
      variables: LIGHT_MODE_VARIABLES
    });
    const { history } = this.props;
    this.unlisten = history.listen(() => appCuesPage());
    this.props.requestSessions();
    this.props.requestWebinars();
    this.props.requestRecordings();

    const { t } = this.context;
    trackAnalyticsDashboard(LANDING_PAGE);
    this.recordingTips = t('tips.tipsList', { returnObjects: true })
      .sort(() => 0.5 - Math.random())
      .slice(0, 3);
    this.sessionsTips = t('tips.tipsList', { returnObjects: true })
      .sort(() => 0.5 - Math.random())
      .slice(0, 3);
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidUpdate(prevProps) {
    const { t } = this.context;
    this.recordingTips = t('tips.tipsList', { returnObjects: true })
      .sort(() => 0.5 - Math.random())
      .slice(0, 3);
    this.sessionsTips = t('tips.tipsList', { returnObjects: true })
      .sort(() => 0.5 - Math.random())
      .slice(0, 3);
    if (this.props.reduced_user.darkMode) {
      cssVars({
        variables: DARK_MODE_VARIABLES
      });
    } else {
      cssVars({
        variables: LIGHT_MODE_VARIABLES
      });
    }

    if (prevProps.reduced_user !== this.props.reduced_user) {
      const {
        reduced_user: {
          entitlements: { isVirtualEventsEnabled, isVirtualEventsEntitled, isVirtualEventsProvisioned }
        }
      } = this.props;
      const virtualEventsEnabled = isVirtualEventsEnabled && isVirtualEventsEntitled && isVirtualEventsProvisioned;
      if (virtualEventsEnabled) {
        this.props.requestVirtualEvents();
      }
    }
  }

  render() {
    const isBig = ScreenUtil.isUp(ScreenUtil.M, this.props.windowWidth);
    const themeClass = this.getThemeClass();
    return (
      <div className={`analyticsDashboard ${themeClass}`}>
        <div className="analyticsHeader">
          <HeaderContainer isBig={isBig} />
        </div>
        <div className="analyticsContent">{this.getContentSection(isBig)}</div>
        <div className="analyticsFooter">
          <FooterComponent />
        </div>
      </div>
    );
  }

  getThemeClass() {
    const { reduced_user } = this.props;
    if (!reduced_user.darkMode) {
      return NEW_EXP_LIGHT_MODE;
    }
    return DARK_MODE;
  }
  getContentSection(isBig) {
    const { match, reduced_user } = this.props;
    const { t } = this.context;

    if (!reduced_user.entitlements.isOrganizerReportGenerationAllowed) {
      return <RobotMessageComponent type={RobotMessageState.NOT_FOUND_STATE} />;
    }
    return (
      <div>
        <div className="contentSection">
          <AnalyticsDashboardHeader isBig={isBig} forceRefreshHack={t('header.analytics')} />
          <div className="contentBody">
            <Switch>
              <Route
                path={match.url + '/sessions/:sessionKey'}
                render={() => <SessionDetailsContainer isBig={isBig} />}
              />
              <Route
                path={match.url + '/recordings/:recordingSource/:recordingKey'}
                render={() => <RecordingDetailsContainer isBig={isBig} />}
              />
              <Route
                path={match.url + '/sessions'}
                render={() => <SessionsContainer isBig={isBig} tips={this.sessionsTips} />}
              />
              <Route
                path={match.url + '/recordings'}
                render={() => <RecordingsContainer isBig={isBig} tips={this.recordingTips} />}
              />
              <Redirect exact from={match.url + '/'} to={match.url + '/sessions'} />
              <Route component={NotFoundComponent} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      reduced_user: state.reduced_user
    }),
    {
      requestSessions: getLastTenSessions,
      requestWebinars: getWebinars,
      requestRecordings: getRecordings,
      requestVirtualEvents: getVirtualEvents
    }
  )(windowSize(AnalyticsDashboard))
);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Dashboard/AnalyticsDashboard.js